import { find } from 'lodash';
import { DealStatusEnum } from 'src/enumerators';

import {
    loadActionsCountRequest,
    loadDealsCountRequest,
    loadDebtsStatusCountRequest,
    loadNextTransferRequest,
    loadPaymentsCountRequest,
    loadPendingDebtsRequest,
    loadSurveysDashboardRequest
} from 'src/repositories/report.repository';


/**
 * Action Types
 */
export const ACTIONS_COUNT_LOADING = 'ACTIONS_COUNT_LOADING';
export const ACTIONS_COUNT_LOADED = 'ACTIONS_COUNT_LOADED';

export const DEALS_COUNT_LOADING = 'DEALS_COUNT_LOADING';
export const DEALS_COUNT_LOADED = 'DEALS_COUNT_LOADED';

export const DEBTS_STATUS_COUNT_LOADING = 'DEBTS_STATUS_COUNT_LOADING';
export const DEBTS_STATUS_COUNT_LOADED = 'DEBTS_STATUS_COUNT_LOADED';

export const NEXT_TRANSFER_LOADING = 'NEXT_TRANSFER_LOADING';
export const NEXT_TRANSFER_LOADED = 'NEXT_TRANSFER_LOADED';

export const PAYMENT_COUNT_LOADING = 'PAYMENT_COUNT_LOADING';
export const PAYMENT_COUNT_LOADED = 'PAYMENT_COUNT_LOADED';

export const PENDING_DEBTS_LOADING = 'PENDING_DEBTS_LOADING';
export const PENDING_DEBTS_LOADED = 'PENDING_DEBTS_LOADED';

export const SURVEYS_DASHBOARD_LOADING = 'SURVEYS_DASHBOARD_LOADING';
export const SURVEYS_DASHBOARD_LOADED = 'SURVEYS_DASHBOARD_LOADED';

/**
 * Action Creators
 */

export const loadingActionsCount = isLoading => ({
    type: ACTIONS_COUNT_LOADING,
    payload: isLoading,
});

export const loadedActionsCount = result => ({
    type: ACTIONS_COUNT_LOADED,
    payload: result,
});


export const loadingDealsCount = isLoading => ({
    type: DEALS_COUNT_LOADING,
    payload: isLoading,
});

export const loadedDealsCount = result => ({
    type: DEALS_COUNT_LOADED,
    payload: result,
});


export const loadingDebtsStatusCount = isLoading => ({
    type: DEBTS_STATUS_COUNT_LOADING,
    payload: isLoading,
});

export const loadedDebtsStatusCount = result => ({
    type: DEBTS_STATUS_COUNT_LOADED,
    payload: result,
});


export const loadingNextTransfer = isLoading => ({
    type: NEXT_TRANSFER_LOADING,
    payload: isLoading,
});

export const loadedNextTransfer = nextTransfer => ({
    type: NEXT_TRANSFER_LOADED,
    payload: nextTransfer,
});


export const loadingPaymentCount = isLoading => ({
    type: PAYMENT_COUNT_LOADING,
    payload: isLoading,
});

export const loadedPaymentCount = result => ({
    type: PAYMENT_COUNT_LOADED,
    payload: result,
});


export const loadingPendingDebts = isLoading => ({
    type: PENDING_DEBTS_LOADING,
    payload: isLoading,
});

export const loadedPendingDebts = result => ({
    type: PENDING_DEBTS_LOADED,
    payload: result,
});


export const loadActionsCount = () => (dispatch) => {
    dispatch(loadingActionsCount(true));
    return loadActionsCountRequest()
        .then(({ data }) => {
            dispatch(loadedActionsCount(data));
        })
        .finally(() => {
            dispatch(loadingActionsCount(false));
        });
};

export const loadDealsCount = () => (dispatch) => {
    dispatch(loadingDealsCount(true));
    return loadDealsCountRequest()
        .then(({ data }) => {
            const parsedStatuses = [];
            Object.keys(data).forEach((key) => {
                const el = find(DealStatusEnum, el => el.key === key);
                if (el) {
                    parsedStatuses.push({
                        name: el.label,
                        color: el.color,
                        value: data[key] || 0,
                    });
                }
            });

            const response = {
                amount: data.amount || 0,
                statuses: parsedStatuses,
            };

            dispatch(loadedDealsCount(response));
        })
        .finally(() => {
            dispatch(loadingDealsCount(false));
        });
};


export const loadDebtsStatusCount = () => (dispatch) => {
    dispatch(loadingDebtsStatusCount(true));
    return loadDebtsStatusCountRequest()
        .then(({ data }) => {
            dispatch(loadedDebtsStatusCount(data));
        })
        .finally(() => {
            dispatch(loadingDebtsStatusCount(false));
        });
};

export const loadNextTransfer = () => (dispatch) => {
    dispatch(loadingNextTransfer(true));
    return loadNextTransferRequest()
        .then(({ data }) => {
            dispatch(loadedNextTransfer(data));
        })
        .finally(() => {
            dispatch(loadingNextTransfer(false));
        });
};

export const loadPaymentCount = (initDate, endDate) => (dispatch) => {
    dispatch(loadingPaymentCount(true));
    return loadPaymentsCountRequest(initDate, endDate)
        .then(({ data }) => {
            dispatch(loadedPaymentCount(data));
        })
        .finally(() => {
            dispatch(loadingPaymentCount(false));
        });
};

export const loadPendingDebts = () => (dispatch) => {
    dispatch(loadingPendingDebts(true));
    return loadPendingDebtsRequest()
        .then(({ data }) => {
            dispatch(loadedPendingDebts(data));
        })
        .finally(() => {
            dispatch(loadingPendingDebts(false));
        });
};

export const loadingDashboardSurveys = isLoading => ({
    type: SURVEYS_DASHBOARD_LOADING,
    payload: isLoading,
});

export const loadedDashboardSurveys = result => ({
    type: SURVEYS_DASHBOARD_LOADED,
    payload: result,
});

export const loadDashboardSurveys = () => (dispatch) => {
    dispatch(loadingDashboardSurveys(true));
    return loadSurveysDashboardRequest()
        .then(({ data }) => {
            dispatch(loadedDashboardSurveys(data));
        })
        .finally(() => {
            dispatch(loadingDashboardSurveys(false));
        });
};